<template>
	<Modal
		modal-name="AgeConfirmationModal"
		type="dialog"
		:closeable="false"
		:theme="$arenaConfig.isLightTheme ? 'light' : 'dark'"
		@closing-modal="handleClosingModal"
	>
		<template #title>
			{{ $I18n.trans('commons.age_confirmation.title') }}
		</template>
		<template #content>
			<p>{{ $I18n.trans('commons.age_confirmation.info') }}</p><br>
			<p>{{ $I18n.trans('commons.age_confirmation.question') }}</p>
		</template>
		<template #footer>
			<div class="l-button-group">
				<V2Button
					:text="$Helpers.ucfirst($I18n.trans('commons.back'))"
					modifier="secondary"
					:theme="$arenaConfig.isLightTheme ? null : 'dark'"
					@click="handleNo"
				/>
				<V2Button
					:text="$Helpers.ucfirst($I18n.trans('commons.age_confirmation.confirm'))"
					modifier="primary"
					:theme="$arenaConfig.isLightTheme ? null : 'dark'"
					@click="handleYes"
				/>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from '@shared/components/Modal';
import V2Button from '@shared/components/Button';

const LOCAL_STORAGE_KEY = 'ageConfirmation18Plus';

export default {
	name:       'AgeConfirmationModal',
	components: { Modal, V2Button },
	methods:    {
		handleYes() {
			// Store confirmation in localStorage
			localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
			this.$emit('confirmed');
			window.eventBus.$emit('modalClose:AgeConfirmationModal', { confirmed: true });
		},
		handleNo() {
			this.$emit('denied');
			window.eventBus.$emit('modalClose:AgeConfirmationModal', { confirmed: false });
		},
		handleClosingModal() {
			this.$emit('closing-modal');
		},
	},
};

export { LOCAL_STORAGE_KEY };
</script>

<style lang="scss" scoped>
.l-button-group {
	display: flex;
	gap: 12px;
	justify-content: flex-end;
}
</style>
